<template>
  <v-text-field
    class="pulse-input"
    outlined
    dense
    hide-details
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-if="icon" #prepend-inner>
      <i :class="[icon, 'pulse-input__icon']" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "PulseInputText",
  inheritAttrs: false,
  props: {
    icon: { type: String, default: "" },
  },
};
</script>
